<template>
  <Modal class-name="vertical-center-modal"
         v-model="isLink"
         width="45%"
         title="推广链接">
    <div class="form-wrapper">
      <div class="operate-div">
        <div>
          <img style="width: 60px;" v-if="pubilcInfo.headImg" :src="pubilcInfo.headImg" alt="">
          <img style="width: 60px;" v-else src="../../assets/img/official/weishouquan.png" alt="">
        </div>
        <div class="wechat-info">
          <div class="wechat-title">{{pubilcInfo.platformName}}</div>
        </div>
      </div>
      <div class="link-title">
        您的影票专属推广链接为：
      </div>
      <div class="link">
        <a target="_blank" :href="link">{{link}}</a>
      </div>
      <div class="link-tip">
        将链接放于您的公众号菜单栏中，会员点击菜单就可以专属购票页面，订单结算后您将获得订单利润分佣。
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="sure()">确定</span>
      </div>
    </div>
  </Modal>
</template>

<script>
  import { getPlatformUuid } from '@/utils/auth'
  import { Modal } from 'view-design'
  export default {
    name: "PromotionLink",
    components: {
      Modal
    },
    props: {},
    created() {},
    data: function () {
      return {
        pubilcInfo: {},
        isLink: false,
        promotionLink: process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=',
        link: ''
      }
    },
    methods: {
      init: function (row) {
        this.isLink = true
        this.pubilcInfo = row
        this.link =  this.promotionLink + row.platformUuid + '&type=1';
      },
      sure: function () {
        this.isLink = false
      }
    }
  }
</script>

<style scoped>
  >>> .ivu-modal-body {
    padding: 16px;
  }
  >>> .ivu-modal-content{
    border-radius: 4px;
  }
  >>> .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal {
    top: 0;
  }
  >>> .ivu-modal-footer {
    border-top: none;
    padding: 0;
  }
  >>> .vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 0px 18px 12px 18px;
    text-align: right;
  }
  .form-wrapper .operate-div{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
    color: #FF8622;
    padding: 10px 0;
  }
  .form-wrapper .operate-div .wechat-info{
    margin: 0 30px 0 15px;
    font-family: Alibaba-PuHuiTi-R;
    width: 130px;
  }
  .form-wrapper .operate-div .wechat-info .wechat-title{
    font-size: 16px;
    color: #666666;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    -webkit-line-clamp: 1;
  }
  .form-wrapper .link-title{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #222222;
    padding-top: 20px;
  }
  .form-wrapper .link{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 12px;
    color: #3D9EFC;
    padding: 6px 0;
  }
  .form-wrapper .link-tip{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 12px;
    color: #666666;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 2px;
    margin-right: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    vertical-align: middle;
    cursor: pointer;
  }
  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }
  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/components/official/PromotionLink.vue